// hooks/useLogout.js
import { useNavigate } from "react-router-dom";
import { logout } from "../services/login";
import { clearLocalStorageExcept } from "../helpers";

export function useLogout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response = await logout();
      if (response) {
        await clearLocalStorageExcept();
        
        navigate("/login", { replace: true });
        
      }
    } catch (error) {
      console.error("Failed to logout", error);
    }
  };

  return handleLogout;
}
